// Complete multi-language dictionary for FizioFit Center (Albanian, Italian, English)

export const TRANSLATIONS = {
  sq: {
    nav: {
      home: "Kryefaqja",
      about: "Rreth Nesh",
      services: "Shërbimet",
      conditions: "Trajtimet",
      gallery: "Galeria",
      faq: "FAQ",
      contact: "Kontakt",
      bookBtn: "Rezervo Takim",
      privacy: "Politika e Privatësisë",
    },
    hero: {
      specializedCenter: "Qendër e Specializuar",
      freeConsultBadge: "KONSULTA ËSHTË FALAS",
      reviews: "Vlerësime",
      h1_1: "Rikthimi i",
      h1_2: "lëvizjes,",
      h1_3: "Rikthen shëndetin.",
      desc: "Trajtime profesionale fizioterapie, terapi manuale dhe rehabilitim fizik në Lushnjë. Kujdes i personalizuar për çdo pacient.",
      bookCta: "Rezervo një Takim",
      servicesCta: "Shiko Shërbimet",
      feat_1: "Konsulta Fillestare 100% FALAS",
      feat_2: "Aparatura Bashkëkohore",
      feat_3: "Hapur 7 Ditë të Javës",
    },
    trust: {
      freeTitle: "0 LEK",
      freeLabel: "Konsulta e Parë",
      freeSub: "100% FALAS",
      ratingLabel: "Vlerësime në Google",
      ratingSub: "Nga pacientët tanë",
      hoursLabel: "Hapur çdo ditë",
      hoursSub: "7 ditë / javë",
      locationLabel: "Vendndodhja",
      locationSub: "Rruga Faik Dervishi, Lushnjë",
    },
    marquee: [
      "Fizioterapi",
      "Rehabilitim",
      "Terapi Manuale",
      "Metoda Mezieres 'Probleme posturale'",
      "Dëmtime Sportive",
      "Metoda Maitland",
      "Ushtrime Terapeutike",
      "Rikuperim pas Operacioneve",
    ],
    about: {
      overline: "01 — Rreth Nesh",
      title: "Kujdes i dedikuar për rikthimin tuaj në lëvizje",
      p1: "Në FizioFit Center trajtojmë çdo pacient si një rast më vete. Fillojmë me një vlerësim të kujdesshëm dhe ndërtojmë një program trajtimi që i përshtatet gjendjes, ritmit dhe objektivave tuaja.",
      p2: "Puna jonë fokusohet te fizioterapia dhe rehabilitimi — nga dhimbjet e përditshme te rikuperimi pas operacioneve apo dëmtimeve sportive. Kombinojmë terapinë manuale, ushtrimet terapeutike dhe aparatura moderne për të mbështetur rikuperimin tuaj.",
      p3: "Qëllimi ynë është i qartë: t'ju ndihmojmë të lëvizni më lirshëm, me më pak dhimbje dhe të ktheheni te aktivitetet që doni.",
      stat1Label: "Vlerësim në Google",
      stat2Label: "Hapur çdo ditë",
      stat3Label: "Trajtim i personalizuar",
    },
    services: {
      overline: "02 — Shërbimet Tona",
      title: "Trajtime të plota fizioterapie dhe rehabilitimi",
      desc: "Zgjidhni shërbimin që ju përshtatet, ose na kontaktoni për t'ju udhëzuar drejt trajtimit të duhur.",
      more: "Më shumë",
      items: [
        {
          icon: "Activity",
          title: "Fizioterapi",
          desc: "Vlerësim dhe trajtim i çrregullimeve të lëvizjes, për të reduktuar dhimbjen dhe përmirësuar funksionin.",
        },
        {
          icon: "HeartPulse",
          title: "Rehabilitim",
          desc: "Programe të strukturuara rikuperimi për të rikthyer forcën, ekuilibrin dhe lëvizshmërinë.",
        },
        {
          icon: "Hand",
          title: "Terapia Manuale",
          desc: "Teknika me duar për nyjet dhe indet e buta, që lehtësojnë dhimbjen dhe tensionin.",
        },
        {
          icon: "Stethoscope",
          title: "Rehabilitim pas operacioneve",
          desc: "Ndjekje e kujdesshme e rikuperimit pas ndërhyrjeve, hap pas hapi.",
        },
        {
          icon: "Dumbbell",
          title: "Rehabilitim pas dëmtimeve sportive",
          desc: "Rikthim i sigurt në aktivitet për sportistët amatorë dhe profesionistë.",
        },
        {
          icon: "Bone",
          title: "Dhimbje muskulore & artikulare",
          desc: "Trajtim i dhimbjeve të muskujve dhe nyjeve me qasje të personalizuar.",
        },
        {
          icon: "Brain",
          title: "Rehabilitim neurologjik",
          desc: "Mbështetje për rikuperimin e lëvizjes dhe koordinimit pas gjendjeve neurologjike.",
        },
        {
          icon: "StretchHorizontal",
          title: "Ushtrime terapeutike",
          desc: "Programe individuale ushtrimesh për të forcuar dhe stabilizuar trupin.",
        },
        {
          icon: "Waves",
          title: "Trajtime me aparatura",
          desc: "Përdorim i aparaturave moderne të fizioterapisë sipas nevojës së trajtimit.",
        },
      ],
    },
    conditions: {
      overline: "03 — Trajtimet",
      title: "Për çfarë mund t'ju ndihmojmë?",
      desc: "Trajtojmë një gamë të gjerë problemesh të lëvizjes dhe dhimbjeve. Nëse gjendja juaj nuk është në listë, na kontaktoni — jemi këtu për t'ju ndihmuar.",
      items: [
        "Dhimbje shpine & hernie diskale",
        "Dhimbje qafe & shpatullash",
        "Dhimbje gjuri & ligamente",
        "Probleme muskulore & kontraktura",
        "Probleme artikulare & artrit",
        "Dëmtime sportive & ndrydhje",
        "Rehabilitim pas operacionit",
        "Kufizim të lëvizshmërisë",
        "Rehabilitim pas frakturave",
        "Skoliozë & korrigjim qëndrimi",
      ],
    },
    why: {
      overline: "04 — Pse FizioFit?",
      title: "Pse të zgjidhni FizioFit Center?",
      items: [
        {
          icon: "UserCheck",
          title: "Trajtim i personalizuar",
          desc: "Çdo pacient ka nevoja të ndryshme — programi ndërtohet posaçërisht për ju.",
        },
        {
          icon: "ShieldCheck",
          title: "Kujdes profesional",
          desc: "Fokus i plotë te pacienti dhe te procesi i sigurt i rikuperimit.",
        },
        {
          icon: "Cpu",
          title: "Pajisje moderne",
          desc: "Aparatura të avancuara të përshtatshme për fizioterapi dhe rikuperim.",
        },
        {
          icon: "Building2",
          title: "Ambient mikpritës",
          desc: "Një hapësirë e pastër, komode dhe e dedikuar për shëndetin tuaj.",
        },
        {
          icon: "Target",
          title: "Fokus te rezultatet",
          desc: "Programe të matshme që përshtaten hap pas hapi sipas ecurisë suaj.",
        },
        {
          icon: "Clock",
          title: "Hapur çdo ditë",
          desc: "Orar fleksibël nga 08:00 deri në 21:00, shtatë ditë të javës.",
        },
      ],
    },
    process: {
      overline: "05 — Procesi",
      title: "Si funksionon?",
      desc: "Një rrugëtim i qartë, hap pas hapi — nga konsulta e parë deri te rikuperimi juaj.",
      steps: [
        { n: "01", title: "Konsultimi Falas", desc: "Vlerësimi fillestar dhe kuptimi i thellë i problemit tuaj pa asnjë pagesë." },
        { n: "02", title: "Plani i Trajtimit", desc: "Identifikimi i metodave më efektive dhe përcaktimi i objektivave." },
        { n: "03", title: "Trajtimi & Terapia", desc: "Kombinim i terapisë manuale, aparaturave dhe ushtrimeve aktive." },
        { n: "04", title: "Rikuperimi i Plotë", desc: "Monitorim i vazhdueshëm i progresit dhe udhëzime parandaluese." },
      ],
    },
    gallery: {
      overline: "06 — Galeria",
      title: "Ambienti Ynë",
      desc: "Një hapësirë e pastër dhe profesionale, e menduar për trajtim dhe rikuperim.",
    },
    testimonials: {
      overline: "07 — Vlerësimet",
      title: "Çfarë thonë pacientët tanë",
      googleReviews: "në Google Reviews",
      readAllBtn: "Shiko në Google Maps",
      writeReviewBtn: "Na Vlerësoni në Google",
      verifiedBadge: "Vlerësim në Google",
      summaryRating: "Vlerësim i Shkëlqyer 5.0",
      summarySub: "Bazuar në 19+ vlerësime reale me 5 yje në Lushnjë",
      items: [
        {
          name: "Arben K.",
          service: "Hernie Diskale & Shpinë",
          text: "Pasi vuaja për muaj me radhë nga dhimbja e mesit, me trajtimet në FizioFit Center munda të kthehem në aktivitet normal brenda pak javësh. Përkushtim dhe profesionalizëm maksimal!",
          role: "Pacient i Verifikuar",
          date: "Para 2 javësh",
        },
        {
          name: "Elena M.",
          service: "Rehabilitim Pas Operacionit",
          text: "Rehabilitimi pas operacionit të ligamentit të gjurit shkoi shkëlqyeshëm falë kujdesit të stafit. Ambienti është shumë i pastër dhe aparaturat moderne bëjnë diferencën.",
          role: "Paciente e Verifikuar",
          date: "Para 1 muaji",
        },
        {
          name: "Genti D.",
          service: "Dëmtim Sportiv në Shpatull",
          text: "Shërbim i shkëlqyer dhe staf shumë i sjellshëm. Më ndihmuan jashtëzakonisht me dëmtimin tim sportiv në shpatull. I rekomandoj me bindje të plotë për këdo në Lushnjë!",
          role: "Pacient i Verifikuar",
          date: "Para 1 muaji",
        },
        {
          name: "Besa T.",
          service: "Terapi Manuale & Qafë",
          text: "Kisha dhimbje të vazhdueshme qafe dhe shpatullash nga puna e gjatë në zyrë. Pas disa seancash me terapi manuale, ndihem plotësisht e lehtësuar. Mirënjohje stafit!",
          role: "Paciente e Verifikuar",
          date: "Para 2 muajsh",
        },
        {
          name: "Krenar S.",
          service: "Metoda Mezieres & Posturë",
          text: "Staf i kualifikuar dhe aparatura moderne. Qasja e tyre për korrigjimin e qëndrimit dhe dhimbjeve kronike më dha rezultat të shpejtë. Klinika numër një në Lushnjë!",
          role: "Pacient i Verifikuar",
          date: "Para 3 muajsh",
        },
        {
          name: "Mira L.",
          service: "Fizioterapi e Përgjithshme",
          text: "Pritje shumë e ngrohtë dhe vlerësim i hollësishëm që në konsultën e parë falas. Ndihesh me të vërtetë në duar të sigurta. Shumë faleminderit FizioFit!",
          role: "Paciente e Verifikuar",
          date: "Para 3 muajsh",
        },
      ],
    },
    faq: {
      overline: "08 — FAQ",
      title: "Pyetje të Shpeshta",
      desc: "Nuk e gjetët përgjigjen? Na shkruani në WhatsApp ose telefononi — jemi të gatshëm t'ju ndihmojmë.",
      items: [
        {
          q: "Çfarë është fizioterapia dhe si më ndihmon?",
          a: "Fizioterapia është disiplinë mjekësore që ndihmon në rikthimin e lëvizshmërisë dhe funksionit optimal të trupit, duke eliminuar dhimbjet përmes terapisë manuale, ushtrimeve terapeutike dhe aparaturave bashkëkohore.",
        },
        {
          q: "A është me të vërtetë konsulta e parë falas?",
          a: "Po! Konsulta fillestare dhe vlerësimi i gjendjes suaj fizike në FizioFit Center kryhet 100% falas dhe pa asnjë detyrim.",
        },
        {
          q: "Sa zgjat një seancë trajtimi?",
          a: "Kohëzgjatja varet nga lloji i trajtimit dhe nevojat specifike të pacientit. Zakonisht një seancë zgjat midis 40 deri në 60 minuta. Plani i detajuar përcaktohet pas konsultës fillestare.",
        },
        {
          q: "A duhet të rezervoj takim paraprakisht?",
          a: "Po, rekomandohet gjithmonë të rezervoni paraprakisht në mënyrë që të mund t'ju dedikojmë kohën dhe vëmendjen maksimale. Mund të rezervoni direkt online në faqe, me telefon ose në WhatsApp.",
        },
        {
          q: "A trajtoni dëmtime sportive dhe kontraktura?",
          a: "Po! Ofrojmë programe të specializuara të rehabilitimit sportiv për rikthim të sigurt dhe të shpejtë në stërvitje, si për atletët profesionistë ashtu edhe për dashamirësit e sportit.",
        },
        {
          q: "Ku ndodhet FizioFit Center dhe cili është orari?",
          a: "Klinika ndodhet në Rrugën Faik Dervishi në Lushnjë. Jemi hapur çdo ditë nga e Hëna në të Diel, ora 08:00 deri në 21:00.",
        },
      ],
    },
    cta: {
      title: "Jeni gati të kujdeseni më mirë për trupin tuaj?",
      badge: "✨ Konsulta Fillestare është 100% FALAS",
      desc: "Na kontaktoni dhe caktoni një takim me specialistët e FizioFit Center.",
      bookBtn: "Rezervo Takim",
      callBtn: "Telefono Tani",
    },
    booking: {
      overline: "09 — Rezervo",
      title: "Rezervo një Takim",
      bannerTitle: "KONSULTA FILLESTARE ËSHTË 100% FALAS!",
      bannerDesc: "Ejani për një vlerësim profesional të problemit tuaj fizik pa asnjë pagesë dhe pa asnjë detyrim.",
      desc: "Plotësoni formularin dhe ekipi ynë do t'ju kontaktojë brenda ditës për të konfirmuar orarin më të përshtatshëm për ju.",
      firstName: "Emër *",
      lastName: "Mbiemër *",
      phone: "Numër Telefoni *",
      service: "Shërbimi *",
      servicePlaceholder: "Zgjidhni shërbimin",
      servicesList: [
        "Konsultë Fillestare (FALAS)",
        "Fizioterapi",
        "Rehabilitim",
        "Terapi Manuale",
        "Metoda Mezieres 'Probleme posturale'",
        "Dëmtime Sportive",
        "Metoda Maitland",
        "Ushtrime Terapeutike",
        "Rikuperim pas Operacioneve",
        "Tjetër / Konsultë e Përgjithshme",
      ],
      date: "Data",
      time: "Ora",
      message: "Mesazhi",
      messagePlaceholder: "Përshkruani shkurt problemin ose nevojën tuaj...",
      submitBtn: "Dërgo Kërkesën",
      submitting: "Duke dërguar...",
      successTitle: "Faleminderit!",
      successDesc: "Kërkesa juaj u dërgua me sukses. Do t'ju kontaktojmë së shpejti për të konfirmuar takimin.",
      sendAnother: "Dërgo një kërkesë tjetër",
      errorFill: "Ju lutem plotësoni emrin, mbiemrin, telefonin dhe shërbimin.",
    },
    contact: {
      overline: "10 — Kontakt",
      title: "Na Vizitoni",
      addressLabel: "Adresa",
      phoneLabel: "Telefon",
      hoursLabel: "Orari",
      hoursVal: "Çdo ditë: 08:00 – 21:00",
      callBtn: "Telefono Tani",
      mapsBtn: "Google Maps",
    },
    footer: {
      tagline: "Klinikë Fizioterapie në Lushnjë. Rikthimi i levizjes, Rikthen shëndetin",
      menu: "Menu",
      contact: "Kontakt",
      privacy: "Politika e Privatësisë",
      rights: "Të gjitha të drejtat e rezervuara.",
    },
    aboutPage: {
      breadcrumbHome: "Kryefaqja",
      breadcrumbCurrent: "Rreth Nesh & Filozofia Klinike",
      clinicTagline: "Qendër e Specializuar Fizioterapie & Rehabilitimi Ortopedik në Lushnjë",
      title: "Rreth Nesh & Filozofia Klinike",
      subtitle: "Evidencë Shkencore · Arsyetim Klinik · Individualizim i Plotë i Çdo Trajtimi",
      freeBadge: "KONSULTA E PARË 100% FALAS",
      ratingBadge: "5.0 ★ në Google Reviews",
      hoursBadge: "Hapur 7 Ditë: 08:00 – 21:00",
      locationBadge: "Rruga Faik Dervishi, Lushnjë",
      ctaBook: "Rezervo Konsultën Falas",
      ctaCall: "Telefono Tani",
      ctaWhatsapp: "Bisedo në WhatsApp",
      ctaMaps: "Hap në Google Maps",
      backHome: "Kthehu te Kryefaqja",
      doctorSection: {
        badge: "Drejtimi Klinik & Fizioterapisti Kryesor",
        name: "Dr. Erlind Mara",
        role: "Fizioterapist Klinik & Drejtues i FizioFit Center",
        educationLabel: "Formimi Akademik:",
        educationText: "Universiteti Katolik 'Zoja e Këshillit të Mirë' (UniZKM)",
        educationDetail: "I diplomuar në universitetin më cilësor dhe më prestigjioz të fizioterapisë dhe shkencave mjekësore në Shqipëri, me standarde akademike dhe bashkëpunim të ngushtë universitar italian.",
        specializationsLabel: "Kualifikimet & Kurset e Avancuara:",
        specializations: [
          {
            title: "Kurs i Certifikuar në Metodën Mézières",
            desc: "Specializim i thelluar në riedukimin postural global, korrigjimin e asimetrive të kolonës (skoliozë, hiperlordozë) dhe relaksimin e zinxhirëve të pasmë muskulorë."
          },
          {
            title: "Kurs i Certifikuar në Maitland Concept",
            desc: "Terapia manuale ortopedike neuromuskuloskeletike sipas standardeve më të larta ndërkombëtare të IFOMPT, për mobilizimin dhe ekzaminimin e kyçeve dhe diskut vertebral."
          },
          {
            title: "Përvoja Klinike në Rehabilitimin Ortopedik & Sportiv",
            desc: "Përkushtim ditor në vlerësimin funksional të thelluar dhe trajtimin e individualizuar në Lushnjë, rikuperim pas operacioneve (proteza, ligamente) dhe dëmtimeve sportive."
          }
        ],
        quote: "Në FizioFit nuk trajtojmë thjesht një fletë analizash apo një rezonancë magnetike; vlerësojmë njeriun, kuptojmë mekanizmin e dhimbjes dhe ndërtojmë zgjidhje afatgjata."
      },
      clinicGalleryTitle: "Ambienti dhe Aparaturat e FizioFit Center",
      clinicGallerySubtitle: "Hapësirë moderne, krevat profesional i terapisë manuale dhe aparatura bashkëkohore të dedikuara për rikuperimin tuaj të sigurt në Lushnjë",
      methodsTitle: "Metodat & Standardet Tona Klinike",
      methods: [
        { name: "Maitland Concept", desc: "Terapia Manuale Ortopedike e avancuar për nyjet dhe shtyllën kurrizore" },
        { name: "Metoda Mézières", desc: "Riedukimi postural global për balancimin e zinxhirëve muskulorë" },
        { name: "Standardet IFOMPT", desc: "Standardi më i lartë ndërkombëtar në mjekësinë rehabilitative manuale" },
        { name: "Evidence-Based Practice", desc: "Vendimmarrje klinike e bazuar në studime shkencore, jo në mite" },
        { name: "Aparatura Moderne", desc: "Teknologji e avancuar bashkëkohore e kombinuar me kineziterapi aktive" },
      ],
      manifestoTitle: "Manifesti Klinik & Përditësimet Profesionale",
      manifestoSubtitle: "Qëndrime dhe analiza profesionale nga stafi i FizioFit Center mbi arsyetimin klinik dhe trajtimin e individualizuar",
      articles: [
        {
          id: "post-vizioni",
          date: "02 Shtator 2026",
          badge: "Filozofia & Vizioni",
          title: "NE JEMI FIZIOFIT CENTER: Përzgjidh Fizioterapistin, jo thjesht fizioterapinë!",
          summary: "Nuk jemi thjesht një qendër fizioterapie. Jemi një vizion që vendos formimin e vazhdueshëm, arsyetimin klinik dhe individualizimin në themel të shëndetit tuaj.",
          paragraphs: [
            "Në FizioFit Center besojmë me bindje se pacienti nuk duhet të trajtohet kurrë vetëm për atë që shfaqet në një fletë ekzaminimi, në një rezonancë magnetike (MRI) apo radiografi. Pacienti para së gjithash duhet të dëgjohet me vëmendje. Duhet të vlerësohet në çdo lëvizje. Duhet të kuptohet në ritmin e tij të jetës. Dhe mbi të gjitha, duhet të trajtohet si një individ i veçantë me nevojat e tij specifike.",
            "Formimi i thelluar në konceptet ndërkombëtare të terapisë manuale – si Maitland Concept, Metoda Mézières për trajtimin postural dhe standardet e IFOMPT – së bashku me përvojën tonë klinike të përditshme në Lushnjë, na ka mundësuar të ndërtojmë një kulturë të re të rehabilitimit. Ne refuzojmë të mbetemi peng i miteve të vjetra popullore si 'mos e përkul kurrizin sepse dëmtohet' apo 'qëndro gjithmonë i ngrirë drejt'.",
            "Ne nuk premtojmë mrekulli të rreme apo shërime magjike brenda natës. Ne ndërtojmë vendime klinike të matshme, transparente dhe të bazuara në shkencë.",
            "Mesazhi ynë për çdo pacient është i qartë: 💪 Përzgjidh FIZIOTERAPISTIN e formuar dhe me arsyetim klinik, 👎 Jo thjesht procedurën e fizioterapisë si një shërbim mekanik pa plan."
          ],
          quote: "Pacienti nuk është një imazh radiografik; është një person që meriton të rikthehet i sigurt dhe pa dhimbje në jetën aktive."
        },
        {
          id: "post-kolona",
          date: "26 Gusht 2026",
          badge: "Arsyetimi Klinik",
          title: "Morfologjia e Kolonës Vertebrale vs. Arsyetimi Klinik",
          summary: "MRI-ja tregon strukturën anatomike, por arsyetimi klinik nga fizioterapisti përcakton rëndësinë e vërtetë të saj për pacientin.",
          paragraphs: [
            "Morfologjia e kolonës vertebrale mund të ketë ndikim në dhimbje, por nuk është automatikisht shkaku kryesor apo i vetëm i saj. Studimet më prestigjioze botërore provojnë se ndryshimet strukturore – si protruzionet diskale, herniet diskale, ndryshimet degjenerative (spondiloartroza), skolioza apo modifikimet e kurbaturave fiziologjike – gjenden rregullisht edhe te persona që nuk kanë pasur kurrë dhimbje!",
            "Sipas udhëzuesve modernë ndërkombëtarë të IFOMPT, ne nuk trajtojmë imazhin radiografik, por pacientin në tërësi. Arsyetimi ynë klinik në FizioFit mbështetet në:",
            "• Anamnezën e hollësishme mjekësore dhe historikun e dhimbjes;",
            "• Sjelljen e simptomave dhe reagimin gjatë lëvizjeve të përditshme;",
            "• Ekzaminimin e thelluar fizik dhe palpator;",
            "• Testet funksionale, biomekanike dhe ato neurologjike;",
            "• Përgjigjen e trupit ndaj lëvizjes dhe ngarkesës progresive;",
            "• Faktorët biopsikosocialë, gjumin dhe nivelin e stresit.",
            "Përfundimi: MRI-ja tregon strukturën anatomike, por arsyetimi klinik përcakton se çfarë ka vërtet rëndësi për trajtimin dhe rikthimin tuaj pa dhimbje."
          ],
          quote: "MRI tregon strukturën, por vetëm arsyetimi klinik i kualifikuar zgjidh dhimbjen reale."
        },
        {
          id: "post-ditet",
          date: "22 Gusht 2026",
          badge: "Evidenca Shkencore",
          title: "Mit vs. Shkencë: Paketat '10 Ditë Terapi' apo Rehabilitimi i Individualizuar?",
          summary: "Rehabilitimi nuk mbyllet sepse mbaruan 10 apo 15 ditë të një kalendari, por kur arrihen objektivat funksionale reale të trupit tuaj.",
          paragraphs: [
            "Nëse me termin 'paketë 10 ditë terapi' nënkuptohet që sapo kalojnë 10 ditë procesi mbyllet automatikisht dhe pacienti konsiderohet i përfunduar, kjo është një qasje e tejkaluar nga shkenca bashkëkohore.",
            "Duhet bërë një dallim thelbësor: 10–15 ditë mund të jenë thjesht faza e parë për reduktimin e inflamacionit akute dhe dhimbjes, por jo domosdoshmërisht kohëzgjatja totale e rikuperimit. Rishikimet sistematike klinike (RCT) mbi pacientët ortopedikë tregojnë qartë se nuk ekziston një recetë me numër fiks ditësh universale për të gjithë.",
            "Në FizioFit Center, ecuria përcaktohet nga individualizimi dhe progresi sipas objektivave funksionale:",
            "Rehabilitimi nuk përfundon kur mbaron numri i seancave të paracaktuara; ai arrin cakun kur pacienti ka rifituar lëvizshmërinë, stabilitetin, forcën muskulore dhe aftësinë për të kryer aktivitetet e dëshiruara me vetëbesim të plotë."
          ],
          quote: "Qëllimi ynë nuk është mbarimi i ditëve, por rikthimi i plotë dhe i qëndrueshëm i funksionit të trupit tuaj."
        },
        {
          id: "post-cilesia",
          date: "19 Gusht 2026",
          badge: "Përkushtimi & Cilësia",
          title: "Pse FizioFit Center? Sepse Cilësia nuk është slogan, është e dokumentuar!",
          summary: "Cilësia në klinikën tonë është rezultat i përgatitjes rigoroze, aparaturave moderne dhe pacientëve që rikthehen me sukses në jetë aktive.",
          paragraphs: [
            "Në FizioFit Center në Lushnjë zbatojmë protokolle bashkëkohore të vlerësuara ndërkombëtarisht. Cilësia jonë nuk është thjesht një pretendim marketingu, por rrjedhojë e përkushtimit të pandërprerë, formimit të vazhdueshëm profesional dhe praktikës klinike të bazuar në evidencë.",
            "Ne nuk kërkojmë të na besoni verbërisht me fjalë. Informohuni, pyesni pacientët tanë të trajtuar ndër vite, shikoni vlerësimet reale në Google dhe rrjete sociale, dhe më pas na besoni shëndetin tuaj.",
            "Sepse për ne, çdo pacient që ecën lirshëm, që rifiton krahun pas operacionit ose ngrihet pa dhimbje shpine, është reklama dhe dëshmia jonë më e madhe."
          ],
          quote: "Cilësia nuk premtohet me fjalë. Ajo dëshmohet me rezultatet e pacientëve tanë."
        },
        {
          id: "post-konsulta",
          date: "18 Gusht 2026",
          badge: "Kujdesi ndaj Pacientit",
          title: "Mjaft me ekzaminime të panevojshme! Filloni me Konsultën 100% FALAS",
          summary: "Përpara se të kryeni ekzaminime të kushtueshme imazherike, filloni me një vlerësim klinik profesional në FizioFit Center.",
          paragraphs: [
            "Në një përqindje të lartë të rasteve me dhimbje muskulo-skeletike, ekzaminimet imazherike të kushtueshme (MRI, skaner, radiografi të përsëritura) nuk janë të domosdoshme që në fazën fillestare.",
            "👉 Filloni gjithmonë me një vlerësim klinik fillestar tek ne – Konsulta e Parë në FizioFit Center është 100% FALAS (0 LEK).",
            "👉 Gjatë këtij vlerësimi, fizioterapisti teston lëvizshmërinë, ekzaminon zonën problematike dhe vetëm nëse konstatohen sinjale klinike (red flags) rekomandohet ekzaminimi specifik imazherik.",
            "Kjo mënyrë pune ju kursen kohë, shpenzime financiare të panevojshme dhe mbi të gjitha ankthin e diagnozave të nxituara."
          ],
          quote: "Vlerësim i saktë fillestar = Vendim i bazuar në shkencë dhe trajtim pa humbje kohe."
        }
      ],
      sidebarTitle: "Të Dhënat e Klinikës",
      sidebarAddressTitle: "Vendndodhja në Lushnjë",
      sidebarAddressDesc: "Rruga Faik Dervishi, Lushnjë, Albania",
      sidebarMapsBtn: "Hap në Google Maps",
      sidebarPhoneTitle: "Telefon & WhatsApp",
      sidebarHoursTitle: "Orari i Shërbimit",
      sidebarHoursValue: "E Hënë – E Diel: 08:00 – 21:00",
      sidebarHoursSub: "Hapur 7 ditë të javës, pa pushim",
      sidebarCategoriesTitle: "Shërbimet & Specialitetet",
      sidebarCategoriesList: [
        "Fizioterapi e Përgjithshme & Ortopedike",
        "Terapi Manuale (Maitland Concept)",
        "Metoda Mézières (Probleme Posturale & Kolonë)",
        "Rehabilitim Pas Ndërhyrjeve Kirurgjikale",
        "Rikuperim pas Dëmtimeve Sportive & Ndrydhjeve",
        "Trajtime me Aparatura Bashkëkohore",
        "Ushtrime Terapeutike & Kineziterapi",
        "Trajtimi i Dhimbjes së Mesit, Qafës & Hernieve"
      ],
      sidebarQuickLinksTitle: "Navigim i Shpejtë në Faqe",
      bookingCardTitle: "Rezervo Konsultën Tënde FALAS",
      bookingCardDesc: "Konsulta e parë kushton 0 LEK. Plotësoni emrin dhe numrin tuaj, dhe stafi do t'ju konfirmojë orarin menjëherë.",
      bookingNamePlaceholder: "Emri dhe Mbiemri juaj *",
      bookingPhonePlaceholder: "Numri i telefonit (p.sh. 068...) *",
      bookingServiceSelect: "Zgjidhni Shërbimin / Problemin *",
      bookingSubmitBtn: "Dërgo Kërkesën Falas",
      bookingSubmitting: "Po dërgohet...",
      bookingSuccess: "Kërkesa u dërgua me sukses! Do t'ju kontaktojmë së shpejti.",
      shareArticle: "Shpërndaj artikullin",
      copiedText: "Linku u kopjua në clipboard!",
    },
  },

  it: {
    nav: {
      home: "Home",
      about: "Chi Siamo",
      services: "Servizi",
      conditions: "Trattamenti",
      gallery: "Galleria",
      faq: "FAQ",
      contact: "Contatti",
      bookBtn: "Prenota Visita",
      privacy: "Informativa Privacy",
    },
    hero: {
      specializedCenter: "Centro Specializzato",
      freeConsultBadge: "PRIMA CONSULENZA GRATUITA",
      reviews: "Recensioni",
      h1_1: "Recuperare il",
      h1_2: "movimento,",
      h1_3: "Restituisce la salute.",
      desc: "Fisioterapia professionale, terapia manuale e riabilitazione fisica a Lushnjë. Cure personalizzate per ogni paziente.",
      bookCta: "Prenota una Visita",
      servicesCta: "Vedi i Servizi",
      feat_1: "Prima Consulenza 100% GRATIS",
      feat_2: "Attrezzature Moderne",
      feat_3: "Aperto 7 Giorni su 7",
    },
    trust: {
      freeTitle: "0 LEK",
      freeLabel: "Prima Consulenza",
      freeSub: "100% GRATIS",
      ratingLabel: "Recensioni su Google",
      ratingSub: "Dai nostri pazienti",
      hoursLabel: "Aperto ogni giorno",
      hoursSub: "7 giorni su 7",
      locationLabel: "Posizione",
      locationSub: "Rruga Faik Dervishi, Lushnjë",
    },
    marquee: [
      "Fisioterapia",
      "Riabilitazione",
      "Terapia Manuale",
      "Metodo Mézières 'Problemi posturali'",
      "Infortuni Sportivi",
      "Metodo Maitland",
      "Esercizi Terapeutici",
      "Recupero Post-Operatorio",
    ],
    about: {
      overline: "01 — Chi Siamo",
      title: "Cura dedicata per il tuo recupero del movimento",
      p1: "Al FizioFit Center trattiamo ogni paziente come un caso unico. Iniziamo con un'attenta valutazione e costruiamo un piano di trattamento su misura per il tuo stato e i tuoi obiettivi.",
      p2: "Il nostro lavoro è incentrato su fisioterapia e riabilitazione — dai dolori quotidiani al recupero dopo interventi chirurgici o infortuni sportivi. Combiniamo terapia manuale, esercizi mirati e macchinari all'avanguardia.",
      p3: "Il nostro obiettivo è chiaro: aiutarti a muoverti liberamente, senza dolore e a tornare alle attività che ami.",
      stat1Label: "Valutazione Google",
      stat2Label: "Aperto ogni giorno",
      stat3Label: "Trattamento 1 a 1",
    },
    services: {
      overline: "02 — I Nostri Servizi",
      title: "Trattamenti completi di fisioterapia e riabilitazione",
      desc: "Scegli il servizio più adatto a te o contattaci per una guida verso il trattamento ideale.",
      more: "Scopri di più",
      items: [
        {
          icon: "Activity",
          title: "Fisioterapia",
          desc: "Valutazione e trattamento dei disturbi motori per ridurre il dolore e migliorare la funzionalità.",
        },
        {
          icon: "HeartPulse",
          title: "Riabilitazione",
          desc: "Programmi strutturati di recupero per ripristinare forza, equilibrio e mobilità.",
        },
        {
          icon: "Hand",
          title: "Terapia Manuale",
          desc: "Tecniche manuali per articolazioni e tessuti molli che alleviano dolore e rigidità.",
        },
        {
          icon: "Stethoscope",
          title: "Riabilitazione post-operatoria",
          desc: "Monitoraggio attento e graduale del recupero dopo interventi chirurgici.",
        },
        {
          icon: "Dumbbell",
          title: "Riabilitazione sportiva",
          desc: "Rientro in sicurezza all'attività agonistica per atleti amatoriali e professionisti.",
        },
        {
          icon: "Bone",
          title: "Dolori muscolari & articolari",
          desc: "Trattamento mirato dei dolori a carico di muscoli e articolazioni.",
        },
        {
          icon: "Brain",
          title: "Riabilitazione neurologica",
          desc: "Supporto al recupero del movimento e della coordinazione dopo patologie neurologiche.",
        },
        {
          icon: "StretchHorizontal",
          title: "Esercizi terapeutici",
          desc: "Programmi personalizzati di esercizi per rafforzare e stabilizzare il corpo.",
        },
        {
          icon: "Waves",
          title: "Terapie strumentali",
          desc: "Utilizzo di apparecchiature fisioterapiche avanzate secondo necessità clinica.",
        },
      ],
    },
    conditions: {
      overline: "03 — Trattamenti",
      title: "Come possiamo aiutarti?",
      desc: "Trattiamo una vasta gamma di disturbi del movimento e dolori fisici. Se la tua condizione non è in elenco, contattaci.",
      items: [
        "Mal di schiena & ernia del disco",
        "Dolori a collo & spalle",
        "Dolori al ginocchio & legamenti",
        "Problemi muscolari & contratture",
        "Disturbi articolari & artrite",
        "Infortuni sportivi & distorsioni",
        "Riabilitazione post-operatoria",
        "Limitazione della mobilità",
        "Recupero dopo fratture",
        "Scoliosi & correzione postura",
      ],
    },
    why: {
      overline: "04 — Perché FizioFit?",
      title: "Perché scegliere FizioFit Center?",
      items: [
        {
          icon: "UserCheck",
          title: "Trattamento personalizzato",
          desc: "Ogni paziente è unico — il programma viene costruito su misura per te.",
        },
        {
          icon: "ShieldCheck",
          title: "Cura professionale",
          desc: "Piena attenzione al paziente e al percorso sicuro di guarigione.",
        },
        {
          icon: "Cpu",
          title: "Attrezzature moderne",
          desc: "Aparati all'avanguardia ideali per fisioterapia e riabilitazione.",
        },
        {
          icon: "Building2",
          title: "Ambiente accogliente",
          desc: "Uno spazio pulito, confortevole e dedicato alla tua salute.",
        },
        {
          icon: "Target",
          title: "Orientati ai risultati",
          desc: "Programmi misurabili che si adattano costantemente ai tuoi progressi.",
        },
        {
          icon: "Clock",
          title: "Aperto tutti i giorni",
          desc: "Orario flessibile dalle 08:00 alle 21:00, sette giorni su sette.",
        },
      ],
    },
    process: {
      overline: "05 — Il Percorso",
      title: "Come funziona?",
      desc: "Un percorso chiaro, passo dopo passo — dalla prima consulenza fino al pieno recupero.",
      steps: [
        { n: "01", title: "Consulenza Gratuita", desc: "Valutazione iniziale approfondita del tuo problema senza alcun costo." },
        { n: "02", title: "Piano Terapeutico", desc: "Individuazione delle tecniche più efficaci e definizione degli obiettivi." },
        { n: "03", title: "Trattamento & Terapia", desc: "Combinazione di terapia manuale, elettromedicali ed esercizio attivo." },
        { n: "04", title: "Pieno Recupero", desc: "Monitoraggio costante dei progressi e indicazioni di prevenzione." },
      ],
    },
    gallery: {
      overline: "06 — Galleria",
      title: "I Nostri Ambienti",
      desc: "Uno spazio pulito e moderno pensato per il massimo comfort e recupero.",
    },
    testimonials: {
      overline: "07 — Testimonianze",
      title: "Cosa dicono i nostri pazienti",
      googleReviews: "su Google Reviews",
      readAllBtn: "Vedi su Google Maps",
      writeReviewBtn: "Lascia una Recensione",
      verifiedBadge: "Recensione su Google",
      summaryRating: "Valutazione Eccellente 5.0",
      summarySub: "Basato su oltre 19 recensioni reali a 5 stelle a Lushnjë",
      items: [
        {
          name: "Arben K.",
          service: "Ernia del Disco & Schiena",
          text: "Dopo mesi di sofferenza per il mal di schiena, con i trattamenti a FizioFit Center sono tornato alla vita normale in poche settimane. Massima professionalità!",
          role: "Paziente Verificato",
          date: "2 settimane fa",
        },
        {
          name: "Elena M.",
          service: "Riabilitazione Post-Operatoria",
          text: "La riabilitazione dopo l'intervento al legamento crociato è andata benissimo grazie alle cure dello staff. Struttura impeccabile e macchinari top.",
          role: "Paziente Verificato",
          date: "1 mese fa",
        },
        {
          name: "Genti D.",
          service: "Infortunio Sportivo alla Spalla",
          text: "Servizio eccellente e staff molto cortese. Mi hanno aiutato enormemente con un infortunio alla spalla. Li consiglio vivamente a chiunque a Lushnjë!",
          role: "Paziente Verificato",
          date: "1 mese fa",
        },
        {
          name: "Besa T.",
          service: "Terapia Manuale & Cervicale",
          text: "Dolori costanti al collo causati dal lavoro prolungato al computer. Dopo alcune sedute di terapia manuale mi sento rinata. Grazie di cuore a FizioFit!",
          role: "Paziente Verificato",
          date: "2 mesi fa",
        },
        {
          name: "Krenar S.",
          service: "Metodo Mézières & Postura",
          text: "Staff molto preparato e macchinari all'avanguardia. Risultati visibili già dalle prime settimane per i miei problemi di postura. La clinica migliore!",
          role: "Paziente Verificato",
          date: "3 mesi fa",
        },
        {
          name: "Mira L.",
          service: "Fisioterapia Generale",
          text: "Accoglienza calorosa e valutazione approfondita fin dalla prima consulenza gratuita. Ci si sente davvero in ottime mani!",
          role: "Paziente Verificato",
          date: "3 mesi fa",
        },
      ],
    },
    faq: {
      overline: "08 — FAQ",
      title: "Domande Frequenti",
      desc: "Non hai trovato la risposta? Scrivici su WhatsApp o chiamaci — siamo sempre disponibili ad aiutarti.",
      items: [
        {
          q: "Cos'è la fisioterapia e come mi può aiutare?",
          a: "La fisioterapia è una disciplina sanitaria che ripristina la funzionalità motoria ed elimina il dolore attraverso terapia manuale, esercizi e moderne apparecchiature.",
        },
        {
          q: "La prima visita di consulto è davvero gratuita?",
          a: "Sì! La prima consulenza e la valutazione clinica iniziale presso FizioFit Center sono al 100% gratuite e senza impegno.",
        },
        {
          q: "Quanto dura una seduta di trattamento?",
          a: "La durata dipende dal tipo di patologia e dalle necessità del paziente. Solitamente dura tra 40 e 60 minuti.",
        },
        {
          q: "È necessario prenotare in anticipo?",
          a: "Sì, raccomandiamo sempre la prenotazione per dedicarvi la massima attenzione e riservare l'orario ideale.",
        },
        {
          q: "Trattate infortuni sportivi e contratture?",
          a: "Certamente! Abbiamo programmi specializzati di riabilitazione sportiva per un rientro rapido e sicuro in campo.",
        },
        {
          q: "Dove si trova la clinica e quali sono gli orari?",
          a: "Siamo in Rruga Faik Dervishi a Lushnjë. Aperti tutti i giorni dal Lunedì alla Domenica, ore 08:00 – 21:00.",
        },
      ],
    },
    cta: {
      title: "Sei pronto a prenderti cura del tuo corpo?",
      badge: "✨ Prima Consulenza 100% GRATUITA",
      desc: "Contattaci subito e fissa un appuntamento con gli specialisti di FizioFit Center.",
      bookBtn: "Prenota Visita",
      callBtn: "Chiama Ora",
    },
    booking: {
      overline: "09 — Prenotazione",
      title: "Prenota un Appuntamento",
      bannerTitle: "LA PRIMA CONSULENZA È 100% GRATUITA!",
      bannerDesc: "Vieni per una valutazione professionale del tuo problema senza alcun costo e senza alcun impegno.",
      desc: "Compila il modulo sottostante e il nostro team ti contatterà in giornata per confermare l'orario più comodo.",
      firstName: "Nome *",
      lastName: "Cognome *",
      phone: "Numero di Telefono *",
      service: "Servizio *",
      servicePlaceholder: "Seleziona il servizio",
      servicesList: [
        "Consulenza Iniziale (GRATUITA)",
        "Fisioterapia",
        "Riabilitazione",
        "Terapia Manuale",
        "Metodo Mézières 'Problemi posturali'",
        "Infortuni Sportivi",
        "Metodo Maitland",
        "Esercizi Terapeutici",
        "Recupero Post-Operatorio",
        "Altro / Consulenza Generale",
      ],
      date: "Data",
      time: "Ora",
      message: "Messaggio",
      messagePlaceholder: "Descrivi brevemente il tuo disturbo...",
      submitBtn: "Invia Richiesta",
      submitting: "Invio in corso...",
      successTitle: "Grazie!",
      successDesc: "La tua richiesta è stata inviata con successo. Ti contatteremo al più presto per confermare.",
      sendAnother: "Invia un'altra richiesta",
      errorFill: "Si prega di compilare nome, cognome, telefono e servizio.",
    },
    contact: {
      overline: "10 — Contatti",
      title: "Vieni a Trovarci",
      addressLabel: "Indirizzo",
      phoneLabel: "Telefono",
      hoursLabel: "Orario",
      hoursVal: "Tutti i giorni: 08:00 – 21:00",
      callBtn: "Chiama Ora",
      mapsBtn: "Google Maps",
    },
    footer: {
      tagline: "Clinica di Fisioterapia a Lushnjë. Recuperare il movimento, recuperare la salute",
      menu: "Menu",
      contact: "Contatti",
      privacy: "Informativa Privacy",
      rights: "Tutti i diritti riservati.",
    },
    aboutPage: {
      breadcrumbHome: "Home",
      breadcrumbCurrent: "Chi Siamo & Filosofia Clinica",
      clinicTagline: "Centro Specializzato di Fisioterapia & Riabilitazione Ortopedica a Lushnjë",
      title: "Chi Siamo & Filosofia Clinica",
      subtitle: "Evidenza Scientifica · Ragionamento Clinico · Piena Individualizzazione del Trattamento",
      freeBadge: "PRIMA CONSULENZA 100% GRATUITA",
      ratingBadge: "5.0 ★ su Google Reviews",
      hoursBadge: "Aperto 7 Giorni: 08:00 – 21:00",
      locationBadge: "Rruga Faik Dervishi, Lushnjë",
      ctaBook: "Prenota Consulenza Gratuita",
      ctaCall: "Chiama Ora",
      ctaWhatsapp: "Chat su WhatsApp",
      ctaMaps: "Apri su Google Maps",
      backHome: "Torna alla Home",
      doctorSection: {
        badge: "Direzione Clinica & Fisioterapista Responsabile",
        name: "Dr. Erlind Mara",
        role: "Fisioterapista Clinico & Direttore di FizioFit Center",
        educationLabel: "Formazione Accademica:",
        educationText: "Università Cattolica 'Nostra Signora del Buon Consiglio' (UniZKM)",
        educationDetail: "Laureato presso il polo universitario medico e di fisioterapia più prestigioso ed elitario in Albania, con standard accademici europei e stretta convenzione universitaria italiana.",
        specializationsLabel: "Specializzazioni & Corsi Avanzati:",
        specializations: [
          {
            title: "Corso Certificato nel Metodo Mézières",
            desc: "Specializzazione avanzata nella rieducazione posturale globale, correzione delle asimmetrie vertebrali (scoliosi, iperlordosi) e riequilibrio delle catene muscolari posteriori."
          },
          {
            title: "Corso Certificato nel Maitland Concept",
            desc: "Terapia manuale ortopedica neuromuscoloscheletrica conforme ai più alti standard internazionali IFOMPT, per la mobilizzazione articolare e vertebrale evidence-based."
          },
          {
            title: "Esperienza Clinica nella Riabilitazione Ortopedica e Sportiva",
            desc: "Pratica clinica pluriennale a Lushnjë, recupero funzionale post-operatorio (protesi, legamenti) e gestione mirata degli infortuni sportivi."
          }
        ],
        quote: "A FizioFit non curiamo una lastra o una risonanza; ascoltiamo la persona, comprendiamo il meccanismo del dolore e costruiamo una ripresa solida e duratura."
      },
      clinicGalleryTitle: "Gli Spazi e la Tecnologia di FizioFit Center",
      clinicGallerySubtitle: "Ambiente moderno, lettino professionale di terapia manuale e attrezzature avanzate per una riabilitazione sicura a Lushnjë",
      methodsTitle: "I Nostri Metodi & Standard Clinici",
      methods: [
        { name: "Maitland Concept", desc: "Terapia Manuale Ortopedica avanzata per articolazioni e colonna vertebrale" },
        { name: "Metodo Mézières", desc: "Rieducazione posturale globale per riequilibrare le catene muscolari" },
        { name: "Standard IFOMPT", desc: "Il più alto standard internazionale nella medicina riabilitativa manuale" },
        { name: "Evidence-Based Practice", desc: "Decisioni cliniche basate sulla ricerca scientifica, non su miti" },
        { name: "Apparecchiature Moderne", desc: "Tecnologia d'avanguardia abbinata a chinesiterapia attiva" },
      ],
      manifestoTitle: "Manifesto Clinico & Aggiornamenti Professionali",
      manifestoSubtitle: "Approfondimenti professionali dello staff di FizioFit Center sul ragionamento clinico e la riabilitazione su misura",
      articles: [
        {
          id: "post-vizioni",
          date: "02 Settembre 2026",
          badge: "Filosofia & Visione",
          title: "NOI SIAMO FIZIOFIT CENTER: Scegli il Fisioterapista, non solo la terapia!",
          summary: "Non siamo semplicemente un centro di fisioterapia. Siamo una visione che mette la formazione continua, il ragionamento clinico e l'ascolto al centro della tua salute.",
          paragraphs: [
            "A FizioFit Center crediamo fermamente che il paziente non debba mai essere trattato solo per ciò che appare in un referto radiologico o in una risonanza magnetica (MRI). Il paziente deve essere ascoltato con cura, valutato nella sua mobilità globale, compreso nella sua quotidianità e, soprattutto, trattato come un individuo unico.",
            "La formazione approfondita nei concetti internazionali di terapia manuale – come il Maitland Concept, il Metodo Mézières per la postura e gli standard IFOMPT – insieme alla nostra pratica clinica a Lushnjë, ci consente di applicare un approccio moderno e scientifico.",
            "Superiamo i vecchi miti passivi del tipo 'non piegare mai la schiena' o 'resta sempre rigido'. Non promettiamo miracoli da un giorno all'altro; costruiamo decisioni cliniche misurabili e durature.",
            "Il nostro messaggio è chiaro: 💪 Scegli il FISIOTERAPISTA qualificato e il giusto ragionamento clinico, 👎 Non una procedura passiva senza un piano terapeutico individuale."
          ],
          quote: "Il paziente non è un'immagine radiografica; è una persona che merita di tornare attiva e senza dolore."
        },
        {
          id: "post-kolona",
          date: "26 Agosto 2026",
          badge: "Ragionamento Clinico",
          title: "Morfologia della Colonna Vertebrale vs. Ragionamento Clinico",
          summary: "La risonanza magnetica mostra la struttura anatomica, ma solo il ragionamento clinico ne determina il significato reale per i tuoi sintomi.",
          paragraphs: [
            "La morfologia della colonna vertebrale può contribuire al dolore, ma non ne è necessariamente la causa primaria. La letteratura scientifica internazionale dimostra che alterazioni strutturali – come protrusioni discali, ernie, artrosi o asimmetrie posturali – sono comunemente presenti anche in individui completamente asintomatici.",
            "Secondo le linee guida IFOMPT, non trattiamo una lastra, ma la persona. Il nostro ragionamento clinico a FizioFit si basa su:",
            "• Anamnesi dettagliata e storia clinica del dolore;",
            "• Comportamento dei sintomi durante la giornata e il movimento;",
            "• Esame fisico completo e palpazione mirata;",
            "• Test funzionali, biomeccanici e neurologici;",
            "• Risposta del corpo al carico graduale e all'esercizio terapeutico;",
            "• Fattori biopsicosociali e qualità del sonno.",
            "In sintesi: la risonanza mostra la struttura, ma la valutazione clinica esperta definisce il percorso reale verso la guarigione."
          ],
          quote: "La MRI mostra la struttura, ma solo il ragionamento clinico qualificato risolve il dolore reale."
        },
        {
          id: "post-ditet",
          date: "22 Agosto 2026",
          badge: "Evidenza Scientifica",
          title: "Mito vs. Scienza: Pacchetti '10 Giorni di Terapia' o Riabilitazione Individualizzata?",
          summary: "La riabilitazione non si conclude perché sono trascorsi 10 o 15 giorni prefissati, ma quando vengono raggiunti i traguardi funzionali del tuo corpo.",
          paragraphs: [
            "L'idea che dopo un ciclo rigido di '10 giorni' il paziente sia automaticamente guarito è scientificamente superata.",
            "10–15 giorni possono essere necessari per gestire la fase acuta e ridurre il dolore, ma il recupero di legamenti, tendini, forza e stabilità richiede una progressione personalizzata. Gli studi non supportano una durata fissa uguale per tutti.",
            "A FizioFit Center, il percorso è strutturato su obiettivi funzionali misurabili: ampiezza di movimento completa, stabilità articolare, forza muscolare e sicurezza nel tornare al lavoro o allo sport senza rischio di recidive."
          ],
          quote: "Il nostro obiettivo non è esaurire le sedute, ma restituire una funzionalità completa e duratura."
        },
        {
          id: "post-cilesia",
          date: "19 Agosto 2026",
          badge: "Qualità & Risultati",
          title: "Perché FizioFit Center? La qualità non è uno slogan, è documentata!",
          summary: "La qualità nella nostra clinica nasce dall'applicazione rigorosa di protocolli moderni, tecnologie avanzate e pazienti che tornano a sorridere.",
          paragraphs: [
            "A FizioFit Center a Lushnjë adottiamo standard internazionali di terapia manuale e rieducazione funzionale.",
            "Non chiediamo di fidarvi solo delle parole. Informatevi, chiedete ai nostri pazienti, consultate le recensioni a 5 stelle su Google e poi affidateci la vostra salute.",
            "La testimonianza più forte del nostro lavoro è ogni paziente che torna a muoversi liberamente senza limitazioni."
          ],
          quote: "La qualità non si promette a parole. Si dimostra con i risultati dei nostri pazienti."
        },
        {
          id: "post-konsulta",
          date: "18 Agosto 2026",
          badge: "Cura del Paziente",
          title: "Basta esami non necessari! Inizia con la Consulenza 100% GRATUITA",
          summary: "Prima di sottoporti a costosi esami strumentali, inizia con una valutazione clinica professionale presso FizioFit Center.",
          paragraphs: [
            "In gran parte dei casi di dolore muscolo-scheletrico, esami strumentali costosi (risonanze, radiografie) non sono indispensabili come primo passo.",
            "👉 Inizia sempre con una valutazione clinica approfondita: la prima consulenza a FizioFit Center è 100% GRATUITA (0 LEK).",
            "👉 Durante la visita, il fisioterapista esamina la mobilità e, solo in presenza di precisi segnali clinici (red flags), consiglierà l'esame più appropriato.",
            "Questo approccio ti fa risparmiare tempo, costi superflui e l'ansia di referti non contestualizzati."
          ],
          quote: "Valutazione corretta fin dal primo giorno = Percorso chiaro e mirato verso il recupero."
        }
      ],
      sidebarTitle: "Dati della Clinica",
      sidebarAddressTitle: "Posizione a Lushnjë",
      sidebarAddressDesc: "Rruga Faik Dervishi, Lushnjë, Albania",
      sidebarMapsBtn: "Apri su Google Maps",
      sidebarPhoneTitle: "Telefono & WhatsApp",
      sidebarHoursTitle: "Orario di Apertura",
      sidebarHoursValue: "Lunedì – Domenica: 08:00 – 21:00",
      sidebarHoursSub: "Aperto 7 giorni su 7, orario continuato",
      sidebarCategoriesTitle: "Specialità & Servizi",
      sidebarCategoriesList: [
        "Fisioterapia Generale & Ortopedica",
        "Terapia Manuale (Maitland Concept)",
        "Metodo Mézières (Postura & Colonna)",
        "Riabilitazione Post-Chirurgica",
        "Recupero da Infortuni Sportivi",
        "Trattamenti con Apparecchiature Moderne",
        "Esercizi Terapeutici & Chinesiterapia",
        "Trattamento di Lombalgie, Cervicali ed Ernie"
      ],
      sidebarQuickLinksTitle: "Navigazione Rapida",
      bookingCardTitle: "Prenota la Tua Consulenza GRATUITA",
      bookingCardDesc: "La prima consulenza costa 0 LEK. Inserisci nome e telefono, e il nostro team ti contatterà subito per confermare l'orario.",
      bookingNamePlaceholder: "Il tuo Nome e Cognome *",
      bookingPhonePlaceholder: "Numero di telefono *",
      bookingServiceSelect: "Seleziona Servizio / Disturbo *",
      bookingSubmitBtn: "Invia Richiesta Gratuita",
      bookingSubmitting: "Invio in corso...",
      bookingSuccess: "Richiesta inviata con successo! Ti contatteremo a breve.",
      shareArticle: "Condividi articolo",
      copiedText: "Link copiato negli appunti!",
    },
  },

  en: {
    nav: {
      home: "Home",
      about: "About Us",
      services: "Services",
      conditions: "Treatments",
      gallery: "Gallery",
      faq: "FAQ",
      contact: "Contact",
      bookBtn: "Book Appointment",
      privacy: "Privacy Policy",
    },
    hero: {
      specializedCenter: "Specialized Clinic",
      freeConsultBadge: "FREE CONSULTATION",
      reviews: "Reviews",
      h1_1: "Restoring",
      h1_2: "movement,",
      h1_3: "Restores health.",
      desc: "Professional physiotherapy, manual therapy and physical rehabilitation in Lushnjë. Personalized care for every patient.",
      bookCta: "Book an Appointment",
      servicesCta: "View Services",
      feat_1: "Initial Consultation 100% FREE",
      feat_2: "Modern Equipment",
      feat_3: "Open 7 Days a Week",
    },
    trust: {
      freeTitle: "0 LEK",
      freeLabel: "First Consultation",
      freeSub: "100% FREE",
      ratingLabel: "Google Reviews",
      ratingSub: "From our verified patients",
      hoursLabel: "Open every day",
      hoursSub: "7 days / week",
      locationLabel: "Location",
      locationSub: "Faik Dervishi Street, Lushnjë",
    },
    marquee: [
      "Physiotherapy",
      "Rehabilitation",
      "Manual Therapy",
      "Mézières Method 'Postural Problems'",
      "Sports Injuries",
      "Maitland Method",
      "Therapeutic Exercises",
      "Post-Surgery Recovery",
    ],
    about: {
      overline: "01 — About Us",
      title: "Dedicated care to restore your movement and vitality",
      p1: "At FizioFit Center, we treat every patient individually. We begin with a careful evaluation and build a customized recovery plan tailored to your condition and goals.",
      p2: "Our core expertise focuses on physiotherapy and rehabilitation — from everyday pain relief to recovery from surgery and sports injuries. We combine manual therapy, targeted exercise, and state-of-the-art technology.",
      p3: "Our mission is clear: helping you move freely without pain and get back to doing what you love.",
      stat1Label: "Google Rating",
      stat2Label: "Open Every Day",
      stat3Label: "1-on-1 Treatment",
    },
    services: {
      overline: "02 — Our Services",
      title: "Comprehensive physiotherapy & rehabilitation care",
      desc: "Choose the service you need, or contact us so we can guide you to the right treatment.",
      more: "Learn more",
      items: [
        {
          icon: "Activity",
          title: "Physiotherapy",
          desc: "Assessment and treatment of movement disorders to reduce pain and restore optimal function.",
        },
        {
          icon: "HeartPulse",
          title: "Rehabilitation",
          desc: "Structured recovery programs to regain strength, balance, and joint mobility.",
        },
        {
          icon: "Hand",
          title: "Manual Therapy",
          desc: "Hands-on techniques for joints and soft tissues that relieve tension and pain.",
        },
        {
          icon: "Stethoscope",
          title: "Post-Surgical Rehabilitation",
          desc: "Careful step-by-step guided recovery following orthopedic surgeries.",
        },
        {
          icon: "Dumbbell",
          title: "Sports Injury Rehabilitation",
          desc: "Safe and fast return-to-sport programs for amateur and professional athletes.",
        },
        {
          icon: "Bone",
          title: "Muscle & Joint Pain Relief",
          desc: "Personalized care targeting acute and chronic musculoskeletal discomfort.",
        },
        {
          icon: "Brain",
          title: "Neurological Rehabilitation",
          desc: "Specialized support for restoring movement and coordination after neurological conditions.",
        },
        {
          icon: "StretchHorizontal",
          title: "Therapeutic Exercises",
          desc: "Tailored exercise prescriptions to strengthen, stabilize, and protect your body.",
        },
        {
          icon: "Waves",
          title: "Advanced Device Therapies",
          desc: "Application of cutting-edge physiotherapy equipment according to clinical needs.",
        },
      ],
    },
    conditions: {
      overline: "03 — Treatments",
      title: "What conditions do we treat?",
      desc: "We treat a wide range of mobility issues and physical pain. If your condition is not listed, contact us — we are here to help.",
      items: [
        "Back pain & herniated discs",
        "Neck & shoulder pain",
        "Knee pain & ligament tears",
        "Muscle strains & contractures",
        "Joint issues & arthritis",
        "Sports injuries & sprains",
        "Post-surgery rehabilitation",
        "Limited mobility & stiffness",
        "Fracture recovery",
        "Scoliosis & posture correction",
      ],
    },
    why: {
      overline: "04 — Why FizioFit?",
      title: "Why choose FizioFit Center?",
      items: [
        {
          icon: "UserCheck",
          title: "Personalized Care",
          desc: "Every patient has unique needs — your recovery program is built specifically for you.",
        },
        {
          icon: "ShieldCheck",
          title: "Professional Excellence",
          desc: "Complete focus on the patient and a safe, evidence-based recovery process.",
        },
        {
          icon: "Cpu",
          title: "Modern Equipment",
          desc: "State-of-the-art physiotherapy and rehabilitation technology.",
        },
        {
          icon: "Building2",
          title: "Welcoming Environment",
          desc: "A clean, comfortable, and modern facility dedicated to your well-being.",
        },
        {
          icon: "Target",
          title: "Results-Oriented",
          desc: "Measurable treatment milestones that adapt continuously to your progress.",
        },
        {
          icon: "Clock",
          title: "Open Every Day",
          desc: "Flexible hours from 08:00 to 21:00, seven days a week.",
        },
      ],
    },
    process: {
      overline: "05 — Our Process",
      title: "How does it work?",
      desc: "A transparent, step-by-step journey — from your initial consultation to complete recovery.",
      steps: [
        { n: "01", title: "Free Consultation", desc: "In-depth initial evaluation of your physical condition with zero cost." },
        { n: "02", title: "Treatment Plan", desc: "Identifying the most effective therapeutic methods and setting recovery goals." },
        { n: "03", title: "Therapy & Treatment", desc: "Targeted combination of manual therapy, devices, and active exercises." },
        { n: "04", title: "Full Recovery", desc: "Continuous progress monitoring and long-term preventive guidance." },
      ],
    },
    gallery: {
      overline: "06 — Gallery",
      title: "Our Clinic",
      desc: "A spotless and modern environment designed for patient comfort and healing.",
    },
    testimonials: {
      overline: "07 — Testimonials",
      title: "What our patients say",
      googleReviews: "on Google Reviews",
      readAllBtn: "View on Google Maps",
      writeReviewBtn: "Leave a Review",
      verifiedBadge: "Google Review",
      summaryRating: "Excellent 5.0 Rating",
      summarySub: "Based on 19+ verified 5-star patient reviews in Lushnjë",
      items: [
        {
          name: "Arben K.",
          service: "Disc Herniation & Back Pain",
          text: "After suffering for months with lower back pain, treatments at FizioFit Center helped me return to normal life in just a few weeks. Outstanding professionalism!",
          role: "Verified Patient",
          date: "2 weeks ago",
        },
        {
          name: "Elena M.",
          service: "Post-Surgery Rehabilitation",
          text: "My rehabilitation after knee ACL surgery went smoothly thanks to the caring staff. The clinic is pristine and modern machines made all the difference.",
          role: "Verified Patient",
          date: "1 month ago",
        },
        {
          name: "Genti D.",
          service: "Sports Shoulder Injury",
          text: "Excellent service and very polite staff. They helped me immensely with my shoulder injury. I highly recommend FizioFit Center to everyone in Lushnjë!",
          role: "Verified Patient",
          date: "1 month ago",
        },
        {
          name: "Besa T.",
          service: "Manual Therapy & Neck Pain",
          text: "Chronic neck and shoulder pain from long hours at the computer. After just a few sessions of manual therapy, I feel completely relieved. Thank you FizioFit!",
          role: "Verified Patient",
          date: "2 months ago",
        },
        {
          name: "Krenar S.",
          service: "Mézières Method & Posture",
          text: "Highly qualified physiotherapists and modern equipment. Noticeable results for my posture within the very first weeks. Number one clinic in Lushnjë!",
          role: "Verified Patient",
          date: "3 months ago",
        },
        {
          name: "Mira L.",
          service: "General Physiotherapy",
          text: "Warm welcome and thorough examination right from the initial free consultation. You genuinely feel in expert hands! Highly recommended!",
          role: "Verified Patient",
          date: "3 months ago",
        },
      ],
    },
    faq: {
      overline: "08 — FAQ",
      title: "Frequently Asked Questions",
      desc: "Didn't find your answer? Reach out on WhatsApp or call us — we are always happy to help.",
      items: [
        {
          q: "What is physiotherapy and how does it help?",
          a: "Physiotherapy is a medical discipline that restores body mobility and relieves pain through manual therapy, therapeutic exercise, and advanced equipment.",
        },
        {
          q: "Is the initial consultation really free?",
          a: "Yes! Your initial consultation and physical condition evaluation at FizioFit Center are 100% free with no financial obligation.",
        },
        {
          q: "How long does a session last?",
          a: "Session length varies by treatment and individual needs, typically ranging between 40 to 60 minutes.",
        },
        {
          q: "Do I need to book in advance?",
          a: "Yes, we recommend booking in advance so our therapists can dedicate full time and attention to your session.",
        },
        {
          q: "Do you treat sports injuries and muscle spasms?",
          a: "Yes! We provide specialized sports rehabilitation protocols for athletes and fitness enthusiasts.",
        },
        {
          q: "Where is the clinic located and what are the hours?",
          a: "We are located on Faik Dervishi Street in Lushnjë. Open every day from Monday to Sunday, 08:00 – 21:00.",
        },
      ],
    },
    cta: {
      title: "Ready to take better care of your body?",
      badge: "✨ Initial Consultation is 100% FREE",
      desc: "Contact us today and schedule a visit with our physiotherapy specialists.",
      bookBtn: "Book Appointment",
      callBtn: "Call Now",
    },
    booking: {
      overline: "09 — Booking",
      title: "Book an Appointment",
      bannerTitle: "INITIAL CONSULTATION IS 100% FREE!",
      bannerDesc: "Come for a professional physical evaluation at zero cost and with no obligations.",
      desc: "Fill out the form below and our team will contact you today to confirm your preferred time.",
      firstName: "First Name *",
      lastName: "Last Name *",
      phone: "Phone Number *",
      service: "Service *",
      servicePlaceholder: "Select a service",
      servicesList: [
        "Initial Consultation (FREE)",
        "Physiotherapy",
        "Rehabilitation",
        "Manual Therapy",
        "Mézières Method 'Postural Problems'",
        "Sports Injuries",
        "Maitland Method",
        "Therapeutic Exercises",
        "Post-Surgery Recovery",
        "Other / General Consultation",
      ],
      date: "Date",
      time: "Time",
      message: "Message",
      messagePlaceholder: "Briefly describe your issue or recovery goals...",
      submitBtn: "Send Request",
      submitting: "Sending...",
      successTitle: "Thank You!",
      successDesc: "Your request was submitted successfully. We will reach out shortly to confirm your appointment.",
      sendAnother: "Send another request",
      errorFill: "Please fill out your first name, last name, phone number, and service.",
    },
    contact: {
      overline: "10 — Contact",
      title: "Visit Us",
      addressLabel: "Address",
      phoneLabel: "Phone",
      hoursLabel: "Opening Hours",
      hoursVal: "Every day: 08:00 – 21:00",
      callBtn: "Call Now",
      mapsBtn: "Google Maps",
    },
    footer: {
      tagline: "Physiotherapy Clinic in Lushnjë. Restoring Movement, Restoring Health",
      menu: "Menu",
      contact: "Contact",
      privacy: "Privacy Policy",
      rights: "All rights reserved.",
    },
    aboutPage: {
      breadcrumbHome: "Home",
      breadcrumbCurrent: "About Us & Clinical Philosophy",
      clinicTagline: "Specialized Physiotherapy & Orthopaedic Rehabilitation Center in Lushnjë",
      title: "About Us & Clinical Philosophy",
      subtitle: "Scientific Evidence · Clinical Reasoning · Tailored Individualized Care",
      freeBadge: "FIRST CONSULTATION 100% FREE",
      ratingBadge: "5.0 ★ on Google Reviews",
      hoursBadge: "Open 7 Days: 08:00 – 21:00",
      locationBadge: "Rruga Faik Dervishi, Lushnjë",
      ctaBook: "Book Free Consultation",
      ctaCall: "Call Now",
      ctaWhatsapp: "Chat on WhatsApp",
      ctaMaps: "Open in Google Maps",
      backHome: "Back to Home",
      doctorSection: {
        badge: "Clinical Leadership & Lead Physical Therapist",
        name: "Dr. Erlind Mara",
        role: "Clinical Physical Therapist & Director of FizioFit Center",
        educationLabel: "Academic Background:",
        educationText: "Catholic University 'Our Lady of Good Counsel' (UniZKM)",
        educationDetail: "Graduated from the most prestigious and rigorous physical therapy medical university in Albania, adhering to European standards and close Italian university collaboration.",
        specializationsLabel: "Specialized Certifications & Courses:",
        specializations: [
          {
            title: "Certified Course in the Mézières Method",
            desc: "Advanced specialization in global postural re-education, spinal alignment correction (scoliosis, hyperlordosis), and myofascial chain release."
          },
          {
            title: "Certified Course in the Maitland Concept",
            desc: "Orthopaedic manipulative physical therapy according to rigorous IFOMPT standards, for joint and vertebral disc mobilization and evidence-based assessment."
          },
          {
            title: "Clinical Expertise in Orthopaedic & Sports Rehabilitation",
            desc: "Years of dedicated patient care in Lushnjë, post-operative recovery (hip/knee arthroplasty, ACL reconstructions), and sports injury protocols."
          }
        ],
        quote: "At FizioFit we do not just treat an MRI scan; we evaluate the person, identify the biomechanical pain generator, and construct lasting functional relief."
      },
      clinicGalleryTitle: "FizioFit Center Facilities & Modern Equipment",
      clinicGallerySubtitle: "Modern rehabilitation space, specialized manual therapy plinths, and state-of-the-art physiotherapy devices in Lushnjë",
      methodsTitle: "Our Clinical Methods & Standards",
      methods: [
        { name: "Maitland Concept", desc: "Advanced Orthopaedic Manual Therapy for spinal and peripheral joints" },
        { name: "Mézières Method", desc: "Global postural re-education to rebalance muscular chains" },
        { name: "IFOMPT Standards", desc: "The highest international standard in manipulative physical therapy" },
        { name: "Evidence-Based Practice", desc: "Clinical decision-making guided by empirical science, not myths" },
        { name: "Modern Equipment", desc: "State-of-the-art physiotherapy devices paired with active kinesiotherapy" },
      ],
      manifestoTitle: "Clinical Manifesto & Professional Insights",
      manifestoSubtitle: "Professional essays and insights from FizioFit Center regarding clinical reasoning and individualized recovery",
      articles: [
        {
          id: "post-vizioni",
          date: "September 02, 2026",
          badge: "Philosophy & Vision",
          title: "WE ARE FIZIOFIT CENTER: Choose the Physical Therapist, not just therapy!",
          summary: "We are not just a physical therapy clinic. We are a philosophy that places continuous education, clinical reasoning, and personalized listening at the core of your health.",
          paragraphs: [
            "At FizioFit Center, we believe that a patient should never be treated solely based on what shows on an MRI or X-ray report. A patient must be listened to attentively, evaluated through functional movement, understood in their daily lifestyle, and, above all, treated as a unique individual.",
            "Our extensive training in internationally recognized manual therapy frameworks – such as the Maitland Concept, the Mézières Postural Method, and IFOMPT standards – combined with day-to-day clinical experience in Lushnjë, enables us to implement modern evidence-based recovery.",
            "We reject outdated myths such as 'never bend your spine' or 'remain rigidly stiff'. We do not make false overnight promises; we build structured, transparent, and science-backed clinical decisions.",
            "Our core message to every patient is clear: 💪 Choose the qualified PHYSICAL THERAPIST and reasoned clinical assessment, 👎 Not a passive, generic procedure without a personalized roadmap."
          ],
          quote: "A patient is not an imaging scan; they are a human being with a story, goals, and the potential for full recovery."
        },
        {
          id: "post-kolona",
          date: "August 26, 2026",
          badge: "Clinical Reasoning",
          title: "Spinal Morphology vs. Clinical Reasoning",
          summary: "An MRI reveals anatomical structure, but skilled clinical reasoning determines its actual clinical relevance for your symptoms.",
          paragraphs: [
            "Spinal morphology can contribute to discomfort, but it is not necessarily the direct or sole cause. Leading international studies consistently demonstrate that structural findings – such as disc bulges, herniations, degenerative osteoarthritis, scoliosis, or curvature variations – are commonly present in people who experience zero pain.",
            "Under modern IFOMPT guidelines, we treat the person, not the radiograph. At FizioFit, our clinical reasoning is built upon:",
            "• Detailed medical history and symptom progression;",
            "• Symptom behavior during everyday postures and movements;",
            "• Comprehensive physical examination and palpation;",
            "• Functional, biomechanical, and neurological testing;",
            "• Response to progressive movement and safe loading;",
            "• Biopsychosocial factors, sleep quality, and stress levels.",
            "Conclusion: An MRI reveals structure, but expert physical therapy evaluation determines what truly matters for your recovery."
          ],
          quote: "The scan shows the anatomy, but clinical reasoning solves the real pain."
        },
        {
          id: "post-ditet",
          date: "August 22, 2026",
          badge: "Scientific Evidence",
          title: "Myth vs. Science: Fixed '10-Day Packages' vs. Goal-Oriented Rehabilitation",
          summary: "Rehabilitation does not finish simply because 10 or 15 days on a calendar have passed; it finishes when functional goals are met.",
          paragraphs: [
            "If a '10-day package' implies that treatment stops automatically regardless of functional progress, that approach is scientifically obsolete.",
            "A critical distinction must be made: 10–15 days may be useful for acute symptom modulation, but true remodeling of ligaments, tendons, and muscular stabilization requires progressive adaptation. Systematic reviews show there is no universal fixed number of days that fits all patients.",
            "At FizioFit Center, your recovery is guided by individualized functional milestones:",
            "Therapy completes or transitions to maintenance when the patient regains full range of motion, stability, functional strength, and confidence to return to work, sports, and daily activities without fear of reinjury."
          ],
          quote: "Our goal is not completing calendar days, but restoring sustainable physical freedom."
        },
        {
          id: "post-cilesia",
          date: "August 19, 2026",
          badge: "Commitment & Quality",
          title: "Why FizioFit Center? Quality is not a slogan, it is documented!",
          summary: "Quality at our clinic stems from rigorous clinical protocols, modern technology, and patients who return to active living.",
          paragraphs: [
            "At FizioFit Center in Lushnjë, we implement evidence-backed protocols in manual therapy, postural alignment, and active rehabilitation.",
            "We do not ask you to trust words blindly. Inquire, speak with patients we have treated, explore our 5.0-star Google reviews, and experience professional care firsthand.",
            "The greatest testament to our work is every individual who walks out pain-free and regains their vitality."
          ],
          quote: "Quality is not promised in slogans. It is demonstrated by our patients' outcomes."
        },
        {
          id: "post-konsulta",
          date: "August 18, 2026",
          badge: "Patient Care",
          title: "Stop unnecessary scans! Begin with a 100% FREE Clinical Consultation",
          summary: "Before undergoing expensive and stressful imaging tests, begin with a thorough physical assessment at FizioFit Center.",
          paragraphs: [
            "In many musculoskeletal conditions, expensive initial imaging (MRIs, repeated X-rays) is not strictly needed on day one.",
            "👉 Always begin with a clinical assessment: the initial consultation at FizioFit Center is 100% FREE (0 LEK).",
            "👉 During this assessment, your therapist tests mobility, localizes the mechanical source of symptoms, and only recommends scans if specific clinical red flags are identified.",
            "This structured approach saves you time, prevents unnecessary medical expenses, and eliminates premature diagnostic anxiety."
          ],
          quote: "Accurate initial assessment = Evidence-based decisions and focused treatment."
        }
      ],
      sidebarTitle: "Practice Details",
      sidebarAddressTitle: "Location in Lushnjë",
      sidebarAddressDesc: "Rruga Faik Dervishi, Lushnjë, Albania",
      sidebarMapsBtn: "Open in Google Maps",
      sidebarPhoneTitle: "Phone & WhatsApp",
      sidebarHoursTitle: "Opening Hours",
      sidebarHoursValue: "Monday – Sunday: 08:00 – 21:00",
      sidebarHoursSub: "Open 7 days a week",
      sidebarCategoriesTitle: "Specialties & Services",
      sidebarCategoriesList: [
        "General & Orthopaedic Physiotherapy",
        "Manual Therapy (Maitland Concept)",
        "Mézières Postural Re-education",
        "Post-Surgical Rehabilitation",
        "Sports Injury & Sprain Recovery",
        "Advanced Electrotherapy Devices",
        "Therapeutic Exercise & Kinesiotherapy",
        "Spine, Neck & Herniated Disc Care"
      ],
      sidebarQuickLinksTitle: "Quick Section Navigation",
      bookingCardTitle: "Book Your FREE Consultation",
      bookingCardDesc: "The initial assessment is 0 LEK. Enter your name and phone number, and our team will contact you promptly to confirm your slot.",
      bookingNamePlaceholder: "Your Full Name *",
      bookingPhonePlaceholder: "Phone Number *",
      bookingServiceSelect: "Select Service / Concern *",
      bookingSubmitBtn: "Submit Free Request",
      bookingSubmitting: "Sending...",
      bookingSuccess: "Request sent successfully! We will contact you shortly.",
      shareArticle: "Share article",
      copiedText: "Link copied to clipboard!",
    },
  },
};

export const LANGUAGES = [
  { code: "sq", label: "Shqip", flag: "🇦🇱", short: "SQ" },
  { code: "it", label: "Italiano", flag: "🇮🇹", short: "IT" },
  { code: "en", label: "English", flag: "🇬🇧", short: "EN" },
];
